// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5560) return "static/css/b2c.133c6a548a27c0321126.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3481":"d43b8f2c2e07ae26a226","6063":"cdc501109af75c3f9df6"}[chunkId] + ".chunk.css";
};